// extracted by mini-css-extract-plugin
module.exports = {"default":"Table_default__1Vg_h","preview":"Table_preview__m00lY","row":"Table_row__2v_3H","name":"Table_name__1KMr4","template":"Table_template__17VDs","edit":"Table_edit__1MKQK"};